import { SIMAElementClassifier, } from "@earthbrain/sima";
import { ArcSegment } from "../../core/geometric-elements/arc-segment";
/**
 * Searches backwards for the preceding ROUTE_COORD element and resolves its survey point.
 */
export function getPrevRouteCoord(elements, currentIndex, surveyPoints) {
    for (let i = currentIndex - 1; i >= 0; i--) {
        const el = elements[i];
        if (el.classifier === SIMAElementClassifier.ROUTE_COORD) {
            const rc = el;
            const point = surveyPoints.get(`${rc.point_number}-${rc.point_name}`);
            if (point)
                return point;
        }
    }
    return undefined;
}
/**
 * Searches forwards for the next ROUTE_COORD element and resolves its survey point.
 */
export function getNextRouteCoord(elements, currentIndex, surveyPoints) {
    for (let i = currentIndex + 1; i < elements.length; i++) {
        const el = elements[i];
        if (el.classifier === SIMAElementClassifier.ROUTE_COORD) {
            const rc = el;
            const point = surveyPoints.get(`${rc.point_number}-${rc.point_name}`);
            if (point)
                return point;
        }
    }
    return undefined;
}
/**
 * Generates interpolated arc points for a simple circular curve (C01).
 */
export function interpolateSimpleCurve(sc, startPoint, endPoint, stepSize = 0.01) {
    const radius = sc.radius;
    const isLargeCircle = sc.direction === 1;
    const arcSegment = ArcSegment.fromRadiusAndTwoPoints({
        start: startPoint.position,
        end: endPoint.position,
        radius,
        isLargeCircle,
        stepSize,
    });
    return arcSegment.points.map((pt) => ({
        point_number: -1,
        point_name: "",
        position: pt,
    }));
}
//# sourceMappingURL=route-utils.js.map